import { UmrnOptions } from "../../store/actions";
import { convertToInr } from "../../utils/cart";

const UmrnDetails: UmrnDetailsProps = function (props) {
  return (
    <div className="transaction-details">
      <div className="redemption-details">
        <div className="keys">
          <div>Mandate amount limit</div>
          <div>Start Date</div>
          <div>End Date</div>
          <div>Bank Name</div>
          <div>Bank Account No</div>
        </div>
        <div className="values">
          <div>{convertToInr(props.mandateLimit)}</div>
          <div>{props.startDate}</div>
          <div>{props.endDate}</div>
          <div>{props.bankName}</div>
          <div>{props.bankAccountNumber}</div>
        </div>
      </div>
    </div>
  );
};

export default UmrnDetails;

interface UmrnDetailsProps extends React.FC<UmrnOptions[number]> {}
